/**
 * Created by iamso on 05.08.19.
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TREASURE_SEARCH_TIMER_TEXT: {
        name: "default",
        size: 40,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.styles.TreasureSearchWindow = {
    delay: 11.5,

    content: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: 8 }
    },

    timer: {
        width: 250,

        positions: [{
            x: { align: "center", dx: 0 }, y: { align: "bottom", dy: 0 }
        }, {
            x: { align: "center", dx: 0 }, y: { align: "bottom", dy: 0 }
        }, {
            x: { align: "center", dx: 0 }, y: { align: "bottom", dy: 0 }
        }]
    }
};
